<template>
  <div class="unit">
    <div @mouseover="show_popover_fn" @mouseout="show_popover_fn" class="item box_picker">
      <!-- <div class="popover" v-show="show_popover">
        <el-switch
          :value="allReplace"
          active-color="#45bf24"
          inactive-color="#cccccc"
          active-value="1"
          inactive-value="0"
          @change="all_replace_fn"
        ></el-switch>
        <span>全文换色</span>
      </div>-->
      <com-color v-show="show_color" class="com-color" :value="colorVal" @upColor="upColorFn"></com-color>
      <div @click="show_color_fn">调色盘</div>
      <!-- <el-color-picker
        class="picker"
        v-model="color"
        show-alpha
        size="suit"
        @change="headleChangeColor"
      ></el-color-picker>-->
    </div>
    <div class="item" @click="popPreviewFn()">预览</div>
    <div class="item" @click="importArticle">导入文章</div>
    <div class="item" @click="clear_ueditor_value_fn()">清空内容</div>
    <!-- <div v-bind:class="{active:active_idx==4}" @click="activeFn(4)">存为模板</div> -->
    <div class="other-btn">
      <div class="item" @click="copy_ueditor_value_fn()">复制全文</div>
      <div class="item" @click="savePic">生成长图</div>
      <div class="item" @click="saveArticle">保存/同步</div>
      <div class="item" @click="resetData">恢复</div>
    </div>
  </div>
</template>

<script>
import * as clipboard from "clipboard-polyfill";
import comColor from "./com-color";

export default {
  name: "comUnit",
  data() {
    return {
      show_popover: false,
      allReplace: "1",
      color: null,
      pop_idx: NaN,
      show_color: false,
      colorVal: "#000001"
    };
  },
  props: ['articleId'],
  methods: {
    resetDialog (val) {
      this.$emit("add_ueditor_value", val);
    },
    linkVal (val) {
      console.log(val, 'jieshou')
      this.$emit("add_ueditor_value", val);
    },
    //调色盘
    show_color_fn() {
      this.show_color = !this.show_color;
    },
    
    //预览
    popPreviewFn() {
      this.$emit("pop_preview");
    },
    saveArticle () {
      const obj = this.articleId
      this.$edit.open('saveArticle', '保存文章', { obj }, { width: '860px', show: true })
    },
    resetData () {
      this.$edit.open('restoreData', '历史版本', {}, { width: '860px', show: true }, this.resetDialog.bind(this))
    },
    importArticle () {
      this.$edit.open('ImportArticle', '导入文章', {}, { width: '40%', show: true }, this.linkVal.bind(this))
    },
    //拷贝编辑器内容
    copy_ueditor_value_fn() {
      var dt = new clipboard.DT();
      let content = editor
        .getContent()
        .split("active")
        .join("");
      dt.setData("text/plain", content);
      dt.setData("text/html", content);
      clipboard.write(dt);
      this.$notify.success('复制成功');
    },
    //清除编辑器内容
    clear_ueditor_value_fn() {
      this.$confirm("是否确认清空内容并新建文档，清空后内容将无法恢复，请自行保存内容","清空内容")
      .then(() => {
        editor.setContent("");
        this.$notify.success('清空成功')
      })
    },
    savePic() {
      const content = editor
        .getContent()
        .split("active")
        .join("");
      if (!content) {
        this.$notify.error('内容不可为空！')
      } else {
        this.$edit.open('growthChart', '生成长图', { content }, { width: '648px', show: true })
      }
    },
    //全文换色 => 显示隐藏
    show_popover_fn() {
      this.show_popover = !this.show_popover;
    },
    //透明度滑块
    all_replace_fn() {
      this.allReplace = this.allReplace == "1" ? "0" : "1";
    },
    //更换颜色
    upColorFn(newColor) {
      var colorPool = [],
        oldColor,
        attrPool = [
          "borderBottomColor",
          "borderTopColor",
          "borderLeftColor",
          "borderRightColor",
          "borderColor",
          "color",
          "backgroundColor"
        ];
      if (this.allReplace == "1") {
        $("#ueditor_0")
          .contents()
          .find(".ihuyiEditor")
          .find("*")
          .each(function(i, node) {
            if (node && node.nodeType == 1) {
              attrPool.map(e => {
                oldColor = node.style[e];
                if (oldColor && !isGreyColor(oldColor)) {
                  node.style[e] = newColor;
                }
              });
            }
          });
      }
    }
  },
  
  components: {
    comColor
  }
};
</script>

<style lang="scss" scoped>
.unit {
  font-size: 14px;
  color: #535353;
  .other-btn{
    margin-top: 60px;
  }
  .item {
    text-align: center;
    background-color: #ffffff;
    border-radius: 5px;
    height: 34px;
    line-height: 34px;
    margin-bottom: 5px;
    margin-right: 5px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    &:hover {
      background-color: $color;
      color: #ffffff;
    }
  }

  .box_picker {
    width: 100px;
    position: relative;
  }

  .picker {
    width: 100%;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
  }

  .active {
    background-color: $color;
    color: #ffffff;
  }

  .popup {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 315px;
    height: 80px;
    line-height: 80px;
    background-color: #f7f7f7;
    border-radius: 10px;
  }
  .popover {
    width: 110px;
    height: 54px;
    position: absolute;
    top: -50px;
    left: 50%;
    color: #535355;
    display: flex;
    padding: 13px 5px 0;
    box-sizing: border-box;
    align-items: top;
    line-height: normal;
    justify-content: space-around;
    background-image: url(../assets/images/bg_popover.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    font-size: 12px;
    transform: translateX(-50%);
  }
  .com-color {
    position: absolute;
    left: 0;
    top: 120%;
    z-index: 1000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/com-unit.vue